<template>
  <section class="exhibition">
    <div class="exhibition-content">
      <h2 class="title">系统构成</h2>
      <div class="bar">
        <div class="circular"></div>
      </div>
      <p class="subheading">
        系统主要分为基础软件和应用软件两大部分
      </p>
      <div class="solution">
        <div class="adaptation-double">
          <div class="solution-content">
            <div class="first">
              <div class="grid-content">
                  <h3 class="subtitle">IOT管理系统</h3>
                  <p class="detailed">
                    配合通信管理机通过物联网技术与现场电力智能设备进行数据采集与监控
                  </p>
              </div>
            </div>
          </div>
          <div class="solution-content">
            <div class="second">
              <div class="grid-content">
                <h3 class="subtitle">业务组态系统</h3>
                <p class="detailed">
                  电力运维基础数据组态系统，包括电力图纸、间隔、视频及工作票管理等
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="adaptation-double">
          <div class="solution-content">
            <div class="third">
              <div class="grid-content">
                <h3 class="subtitle">支撑服务</h3>
                <p class="detailed">
                  为系统平台提供基础互联网信息服务，如存储、消息、视频转码等
                </p>
              </div>
            </div>
          </div>
          <div class="solution-content">
            <div class="third">
              <div class="grid-content">
                <h3 class="subtitle">应用软件系统</h3>
                <p class="detailed">
                  提供如电力监控、资产管理、调度指挥等业务系统，可按需求定制模块
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="contact-us">
        <div class="contact-us-text">
          <h3 class="top-text">对我们有什么问题吗</h3>
          <p class="bottom-text">请随时与我们联系</p>
        </div>
        <button class="jump">联系我们</button>
      </div> -->
    </div>
  </section>
</template>

<script>
export default {
  name: "exhibition"
}
</script>

<style lang="scss" scoped>
.exhibition {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 70px;
  padding-bottom: 70px;
  margin-right: auto;
  margin-left: auto;
  // height: 421px;

  @media (max-width: 260px) {
    height: 100%;

    .grid-content {
      width: 219px;
    }

    .solution {
      display: inline;
    }

    .adaptation-double {
      display: inline;
    }
  }

  @media (max-width: 576px) {
    height: 100%;
    max-width: 540px;
    width: auto;
    padding-right: 10px;
    padding-left: 10px;

    .subheading {
      padding: 0 15px;
      text-align: left;
      text-indent: 25px;
    }

    .solution {
      justify-content: space-around;
    }

    .adaptation-double {
      display: inline;
    }

    .contact-us {
      display: block;
      padding: 20px 30px 20px 30px;

      .jump {
        position: initial;
      }
    }

    .contact-us-text {
      text-align: center;
      margin-bottom: 20px;
    }
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1040px;
  }
}

.exhibition-content {
  background: url("../../assets/img/footer-back.png") no-repeat 100% 100%;
}

.title {
  font-size: 22px;
  margin: 0;
}

.bar {
  height: 4px;
  width: 90px;
  background: #cdf1d8;
  margin: 20px auto;
  position: relative;
  border-radius: 40px;

  .circular {
    position: absolute;
    left: 0;
    top: -3.2px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: #44ce6f;
    animation: mymove 4s infinite;
    -webkit-animation: mymove 4s infinite; /*Safari and Chrome both*/
    
    @keyframes mymove {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }

    @-webkit-keyframes mymove /*Safari and Chrome*/ {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
  }
}

.subheading {
  font-size: 14px;
  max-width: 520px;
  margin: 0 auto;
  margin-bottom: 30px;
  color: #6084a4;
  line-height: 1.9;
}

.solution {
  display: flex;
  justify-content: space-between;
  &:last-child {
    margin-bottom: 0;
  }
}

.adaptation-double {
  display: flex;
  width: 50%;
}

.solution-content {
  position: relative;
  padding: 0 15px;
  flex: 1;
}

.grid-content {
  position: relative;
  text-align: center;
  margin-bottom: 30px;

  .subtitle {
    color: #44ce6f;
    font-family: Arial;
    font-size: 18px;
    font-weight: 500;
    margin-top: 20px;
    margin-bottom: 7px;
    line-height: 1.2;
  }

  .detailed {
    margin: 0;
    color: #6084a4;
    line-height: 32px;
    font-size:14px
  }
}

.contact-us {
  display: flex;
  margin: 40px auto 0;
  max-width: 320px;
  min-width: 170px;
  border: 1px dashed #ebebeb;
  padding: 30px 210px 30px 30px;
  border-radius: 5px;
  position: relative;

  .jump {
    background-color: #44ce6f;
    box-shadow: 0 13px 27px 0 rgba(68, 206, 111, 0.25);
    position: absolute;
    right: 30px;
    top: 50%;
    margin-top: -27px;
    color: #ffffff;
    border: none;
    padding: 15px 40px;
    border-radius: 4px;
    z-index: 1;
    text-transform: uppercase;
    transition: 0.5s;
    font-weight: 600;
    font-size: 14px;

    &:hover {
      cursor: pointer;
      background: #c679e3;
      box-shadow: 0 13px 27px 0 rgba(198, 121, 227, 0.25);
    }
  }
}

.contact-us-text {
  text-align: left;

  .top-text {
    font-size: 16px;
    margin-top: 0px;
    margin-bottom: 6px;
    color: #0e314c;
    line-height: 1.2;
  }
  
  .bottom-text {
    font-size: 14px;
    color: #6084a4;
    line-height: 1.9;
    margin: 0;
  }
}
</style>